<template>
  <div class="content bg-white" style="padding-top:20px;">
    <div class="filter">
      <el-button size="medium" style="margin-left:15px;" type="primary" @click="addAttachment">新增</el-button>
      
      <el-select v-model="parameter.userId" placeholder="邮箱/手机号" filterable remote reserve-keyword size="medium" class="default-maggin-left" style="width: 200px;margin-left: 15px" @change="getAttachmentList" :remote-method="remoteMethod" clearable @focus="initUserOptions" @clear="initUserOptions">
        <!-- <el-option v-for="item in userOptions" :label="item.email" :key="item.userId" :value="item.userId"></el-option> -->
        <el-option v-for="item in userOptions" :key="item.userId" :label="item.showName" :value="item.userId" :title="item.showName" />
      </el-select>
      <el-select v-model="parameter.type" size="medium" clearable placeholder="配件类型" style="width: 120px; margin-left: 15px" @change="getAttachmentList">
        <el-option label="Tags" value="Tags" />
        <el-option label="Bags" value="Bags" />
        <el-option label="Cards" value="Cards" />
      </el-select>


      <el-select v-model="parameter.paramType" size="medium" style="width:110px;margin-left: 15px" class="rightBorderNone">
        <el-option label="配件SKU" :value="1" />
        <el-option label="配件名称" :value="2" />
      </el-select>
      <el-input v-model="parameter.paramValue" size="medium" placeholder="请输入" style="width:300px;margin-right:12px" clearable @change="getAttachmentList">
        <el-button slot="append" icon="el-icon-search" @click="getAttachmentList"></el-button>
      </el-input>
      <span style="color:red; font-size:14px;float:right;">注：Tags（吊牌）、Bags（包装袋）一个SKU一个；Cards（卡片）一个包裹一个</span>
    </div>

    <el-table :data="tableData" height="calc(100vh - 198px)" style="width: 100%; margin-top: 30px;">
      <!-- <el-table-column prop="email" label="客户邮箱"/> -->
      <el-table-column prop="email" label="邮箱/手机号">
        <template slot-scope="{row}">
          <div>{{ row.email }}</div>
          <div>{{ row.phone }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="配件类型"/>
      <el-table-column prop="bindStyle" label="绑定方式"/>
      <el-table-column prop="typeName" label="配件中文名"/>
      <el-table-column label="配件产品" width="500px">
        <template slot-scope="{ row }">
            <el-popover placement="right" trigger="hover">
              <el-image :src="row.imageUrl" fit="cover" style="width: 400px;"/>
              <el-image slot="reference" :src="row.imageUrl" fit="cover" style="height: 60px; width: 60px" class="stock-img" />
            </el-popover>
            <div style="display: inline-block;margin-left: 10px">
              <el-tooltip v-if="row.name" class="item" effect="dark" :content="row.name" placement="top-start">
                <div class="ellipsis" style="width: 400px">{{ row.name ? row.name : '-'  }}</div>
              </el-tooltip>
              <div v-if="row.skuCode">{{ row.skuCode }}</div>
            </div>
          </template>
      </el-table-column>
      <el-table-column prop="modifyName" label="最后更新人"/>
      <el-table-column prop="modifyDate" label="最后更新时间">
          <template slot-scope="{ row }">
            <span>{{row.modifyDate|dateFormat}}</span>
          </template>
        </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="{ row }">
          <el-button type="text" @click="() => editAttachment(row)">编辑</el-button>
          <el-button type="text" @click="() => deleteAttachment(row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  
    
    <!-- 页脚 -->
    <footer class="common-footer">
      <el-pagination background :current-page="parameter.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="parameter.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </footer>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="30%" :before-close="handleCloseDialog" :close-on-click-modal="false">
      <el-form ref="form" label-position="right" :model="form" :rules="rules" >
        <el-form-item label="邮箱/手机号" prop="userId">
          <el-select v-model="form.userId" placeholder="邮箱/手机号" filterable remote reserve-keyword size="medium" class="default-maggin-left" style="width: 400px;"  :remote-method="remoteMethod" clearable @focus="initUserOptions" @clear="initUserOptions">
            <!-- <el-option v-for="item in userOptions" :label="item.email" :key="item.userId" :value="item.userId"></el-option> -->
            <el-option v-for="item in userOptions" :key="item.userId" :label="item.showName" :value="item.userId" :title="item.showName" />
          </el-select>
        </el-form-item>
        <el-form-item label="配件类型" prop="type">
          <el-select v-model="form.type" size="medium" placeholder="请选择配件类型" style="width: 400px;" @change="handleTypeChange">
            <el-option label="Tags" value="Tags" />
            <el-option label="Bags" value="Bags" />
            <el-option label="Cards" value="Cards" />
          </el-select>
        </el-form-item>
        <el-form-item label="绑定方式" prop="bindStyle">
          <el-radio-group v-model="form.bindStyle" disabled>
            <el-radio label="一个SKU一个">一个SKU一个</el-radio>
            <el-radio label="一个包裹一个">一个包裹一个</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="配件中文名" prop="typeName">
          <el-input v-model="form.typeName" size="medium" placeholder="请输入" style="width: 400px;"/>
        </el-form-item>
        <el-form-item label="配件SKU" prop="skuCode">
          <el-input v-model="form.skuCode" size="medium" placeholder="请输入" style="width: 400px;" @blur="searchSkuInfo" @input="isSearchSku = false"/>
          <p style="color:red;">(失去焦点时,获取商品图片和名称)</p>
        </el-form-item>
        <el-form-item>
          <el-popover placement="right" trigger="hover">
              <el-image :src="form.imageUrl" fit="cover" style="width: 400px;"/>
              <el-image slot="reference" :src="form.imageUrl" fit="cover" style="height: 160px; width: 160px" class="stock-img" />
            </el-popover>
            <div v-if="form.name">{{ form.name }}</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleCloseDialog">取 消</el-button>
        <el-button size="medium" type="primary" :disabled="!isSearchSku" @click="handleConfirmDialog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
   
</template>
<script>
import API from '@/api'
import _ from 'lodash'

export default {
  name: 'service_attachment',
  data() {
    return {
      tableData: [], // 表格数据源
      userOptions: [], //邮箱下拉数据源
      parameter: {
        paramType: 1, //默认配件sku
        pageSize: 20, // 每页显示条数
        pageNumber: 1 // 当前页
      }, // 获取材质列表的请求参数
      total: 0, // 分页总数

      title: '添加', // 对话框表头
      dialogVisible: false, // 控制对话框的显示与隐藏
      form: {
        type: 'Tags',
        bindStyle: '一个SKU一个'
      }, // 对话框中表单的绑定值
      rules: {
        userId: [{ required: true, message: '请选择客户邮箱', trigger: ['blur', 'change'] }],
        bindStyle: [{ required: true, message: '请选择绑定方式', trigger: ['blur', 'change'] }],
        type: [{ required: true, message: '请选择配件类型', trigger: ['blur', 'change'] }],
        typeName: [{ required: true, message: '请输入配件中文名', trigger: ['blur', 'change'] }],
        skuCode: [{ required: true, message: '请输入配件SKU', trigger: ['blur', 'change'] }]
      },
      isSearchSku: false
    }
  },
  created() {
    this.getUserOptions()
    this.getAttachmentList()
  },
  methods: {
    // 配件绑定列表
    async getAttachmentList(call = true) {
      try {
        if (call) this.resetPage()
        // 配件输入值去除前后空格
        if (this.parameter.paramValue) {
          this.parameter.paramValue = this.parameter.paramValue.trim()
        }
        let { data } = await API.getAttachmentList(this.parameter)
        this.total = data.total
        this.tableData = data.list
      } catch (error) {
        throw new Error(error.message)
      }
      this.$tableScrollTop()
    },
    resetPage() {
      this.parameter.pageNumber = 1
    },
    async getUserOptions() {
      let { data } = await API.getUserOptions({
        pageNumber: 1,
        pageSize: 20,
        email: this.parameter.email
      })
      this.userOptions = data.list
    },
    initUserOptions() {
        this.remoteMethod()
    },
    /**
     * 用户邮箱远程搜索
     *
     * @param {String} query 搜索关键字
     */
     remoteMethod(query) {
      console.log(111)
      if (query) {
        this.parameter.email = query.trim()
      } else {
        this.parameter.email = undefined
      }
      this.getUserOptions()
    },
    // 查询商品
    searchSkuInfo() {
      this.isSearchSku = false
      if(this.form.skuCode !== '' && this.form.skuCode !== undefined){
        API.getAttachmentSkuInfo({ skuCode: this.form.skuCode }).then(({ code, data, message }) => {
          if (code !== 10000) return this.$message.error(message)
          if (!data.mainPath) return this.$message.error('SKU图片为空')
          if (!data.skuName) return this.$message.error('SKU名称为空')
          this.$set(this.form, 'imageUrl', data.mainPath)
          this.$set(this.form, 'name', data.skuName)
          this.isSearchSku = true
        })
      }
    },
    // 添加配件
    addAttachment() {
      this.title = '新增'
      this.dialogVisible = true
      this.parameter.email = undefined
      this.getUserOptions()
    },

    // 编辑配件
    async editAttachment(row) {
      this.parameter.email = row.email ? row.email : row.phone
      this.getUserOptions()
      this.title = '编辑'
      this.dialogVisible = true
      this.form = _.cloneDeep(row)
      this.isSearchSku = true
    },

    // 删除配件
    deleteAttachment(id) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let result = await API.deleteAttachment(id)
        if (result.code === 10000) {
          this.$message.success(result.message)
          this.getAttachmentList()
        } else {
          this.$message.error(result.message)
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 每页显示条数改变时的回调
    handleSizeChange(value) {
      this.parameter.pageSize = value
      this.getAttachmentList(false)
    },
    // 当前页发生改变时触发的回调
    handleCurrentChange(value) {
      this.parameter.pageNumber = value
      this.getAttachmentList(false)
    },
    

    // 对话框关闭的回调
    handleCloseDialog() {
      this.form = {}
      this.isSearchSku = false
      this.dialogVisible = false
      this.$refs.form.resetFields()
    },

    // 对话框确认的回调
    handleConfirmDialog() {
      if (!this.form.imageUrl) {
        return this.$message.error("配件图片不能为空")
      }
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        let result = await API.editAttachment(this.form)
        if (result.code === 10000) {
          this.$message.success(result.message)
          this.handleCloseDialog()
          this.getAttachmentList(false)
        } else {
          this.$message.error(result.message)
        }
      })
    },
    // 清空邮箱下拉后重新获取用户列表
    handleClear() {
      this.$set(this.$data, 'parameter', {
        pageSize: 20,
        pageNumber: 1
      })
      this.getUserOptions()
    },
    handleTypeChange() {
      // 当配件类型改变时触发，可以在这里进行其他逻辑处理
      // 如果需要在配件类型改变时自动设置绑定方式，可以在这里实现
      if (this.form.type === 'Cards') {
        this.form.bindStyle = '一个包裹一个';
      } else {
        this.form.bindStyle = '一个SKU一个';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  height: 600px;
  overflow: auto;
}
.common-footer {
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: flex-end;
}
</style>